import React from 'react';
import { Modal, Alert } from 'antd';
import { formatDate } from '../../utils/directOrderStatus';

/**
 * Presentational modal for replacing a direct order's attachments.
 * The caller owns the file list and the upload request.
 */
const ReuploadModal = ({ order, files, onFilesChange, onOk, onCancel, loading }) => (
  <Modal
    title={order ? `Replace attachments for DO-${order.doRef}` : 'Replace attachments'}
    open={Boolean(order)}
    onOk={onOk}
    onCancel={onCancel}
    okText="Replace attachments"
    cancelText="Cancel"
    confirmLoading={loading}
    okButtonProps={{ disabled: files.length === 0 }}
    rootClassName="do-root do-scope"
    width={560}
    destroyOnClose
  >
    {order && (
      <>
        <p className="do-muted" style={{ margin: '0 0 16px' }}>
          {order.doSupplier} · {formatDate(order.doDate)}
        </p>
        <Alert
          type="warning"
          showIcon
          message="This deletes the existing attachments and replaces them with the files you choose."
          style={{ marginBottom: 16 }}
        />
        <label htmlFor="do-reupload-files" style={{ display: 'block', fontWeight: 500, marginBottom: 6 }}>
          Files (up to 10)
        </label>
        <input
          id="do-reupload-files"
          type="file"
          multiple
          onChange={onFilesChange}
          style={{
            display: 'block',
            width: '100%',
            padding: 10,
            border: '1px dashed var(--do-line-strong)',
            borderRadius: 6,
            background: 'var(--do-canvas)',
            cursor: 'pointer',
          }}
        />
        {files.length > 0 && (
          <ul className="do-optionlist" style={{ marginTop: 12, maxHeight: 200, border: '1px solid var(--do-line)', borderRadius: 6 }}>
            {files.map((file) => (
              <li key={`${file.name}-${file.size}`} style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                <span className="do-clamp">{file.name}</span>
                <span className="do-muted do-num">{(file.size / 1024 / 1024).toFixed(2)} MB</span>
              </li>
            ))}
          </ul>
        )}
      </>
    )}
  </Modal>
);

export default ReuploadModal;
